<template>
  <svg xmlns="http://www.w3.org/2000/svg"
       :width="width"
       :height="height"
       viewBox="0 0 18 18"
       role="presentation"
       @click="$emit('click')">
    <g :fill="disabled ? disabledStateColor : iconColor">
      <path d="M17 7.8V5.667a1.5 1.5 0 0 0-1.5-1.5h-.615v.859a1.308 1.308 0 0 1-2.616 0v-.86H5.731v.86a1.308 1.308 0 0 1-2.616 0v-.86H2.5a1.5 1.5 0 0 0-1.5 1.5V7.8a.995.995 0 0 1 .5-.133h15c.182 0 .353.048.5.133zM5.73 3.167h6.54v-.86a1.308 1.308 0 0 1 2.615 0v.86h.615a2.5 2.5 0 0 1 2.5 2.5V15a2.5 2.5 0 0 1-2.5 2.5h-13A2.5 2.5 0 0 1 0 15V5.667a2.5 2.5 0 0 1 2.5-2.5h.615v-.86a1.308 1.308 0 1 1 2.616 0v.86zM8.039 9a1 1 0 0 0-1 1v.667a1 1 0 0 0 1 1h.616a1 1 0 0 0 1-1V10a1 1 0 0 0-1-1h-.616zm0 4a1 1 0 0 0-1 1v.667a1 1 0 0 0 1 1h.616a1 1 0 0 0 1-1V14a1 1 0 0 0-1-1h-.616zm5.231-4a1 1 0 0 0-1 1v.667a1 1 0 0 0 1 1h.616a1 1 0 0 0 1-1V10a1 1 0 0 0-1-1h-.616zm-9.154 4a1 1 0 0 0-1 1v.667a1 1 0 0 0 1 1h.616a1 1 0 0 0 1-1V14a1 1 0 0 0-1-1h-.616z"/>
    </g>
  </svg>
</template>

<script>
  import iconMixin from './iconMixin.js'

  export default {
    mixins: [iconMixin]
  }
</script>
